if (!customElements.get('email-popup')) {
  customElements.define('email-popup', class EmailPopup extends HTMLElement {
    constructor() {
      super();

      if (window.location.pathname === "/challenge") {
        return;
      }

      this.popup = this.querySelector(".email__popup--mdoal__content");
      this.closePopup = this.querySelectorAll(".email__popup--toggle, .email-popup-overlay");
      this.hidePopup = this.querySelector('.email__popup--hide');

      this.cookieName = "email-popup";
      this.sessionKey = "email-popup-session";

      this.closePopup.forEach((item) => {
        item.addEventListener("click", this.close.bind(this));
      });

      this.hidePopup?.addEventListener("click", this.hide.bind(this));

      // Mostra popup solo se:
      // - non è già stato visto in questa sessione
      // - non è attivo il blocco di 5/6 giorni
      // - oppure se sei in modalità test
      if (this.dataset.mode === "test" || this.shouldOpen()) {
        this.init();
      }

      if (Shopify.designMode) {
        document.addEventListener("shopify:section:load", (event) =>
          editorShopifyEvent(event, this, () => this.open.bind(this))
        );
        document.addEventListener("shopify:section:select", (event) =>
          editorShopifyEvent(event, this, this.open.bind(this))
        );
        document.addEventListener("shopify:section:deselect", (event) =>
          editorShopifyEvent(event, this, this.close.bind(this))
        );
      }
    }

    shouldOpen() {
      const shownThisSession = sessionStorage.getItem(this.sessionKey);
      const cookieExists = this.getCookie(this.cookieName);

      if (shownThisSession) return false;
      if (cookieExists) return false;

      return true;
    }

    // Init popup
    init() {
      if (Shopify && Shopify.designMode) {
        return;
      }

      setTimeout(() => {
        this.open();
      }, parseInt(this.dataset.delay) * 1000);
    }

    // Open popup
    open() {
      document.body.classList.add('email-popup-show');
      this.popup.classList.add('popup-open');

      // Segna come visto nella sessione
      sessionStorage.setItem(this.sessionKey, "true");
    }

    // Chiusura normale: chiude e salva anche il blocco per X giorni
    close() {
      this.popup.classList.add('popup-closing');
      setTimeout(() => {
        this.popup.classList.remove('popup-open');
        this.popup.classList.remove('popup-closing');
        document.body.classList.remove('email-popup-show');
      }, 500);

      if (this.dataset.mode === "test") {
        this.removeCookie(this.cookieName);
        sessionStorage.removeItem(this.sessionKey);
        return;
      }

      // Salva sul dispositivo per X giorni
      this.setCookie(this.cookieName, this.dataset.expire);
    }

    // "No thanks" -> stessa logica: chiude e salva per X giorni
    hide() {
      this.popup.classList.add('popup-closing');
      setTimeout(() => {
        this.popup.classList.remove('popup-open');
        this.popup.classList.remove('popup-closing');
        document.body.classList.remove('email-popup-show');
      }, 500);

      this.setCookie(this.cookieName, this.dataset.expire);
      sessionStorage.setItem(this.sessionKey, "true");
    }

    getCookie(name) {
      const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
      return match ? match[2] : null;
    }

    setCookie(name, expiry) {
      document.cookie = `${name}=true; max-age=${expiry * 24 * 60 * 60}; path=/`;
    }

    removeCookie(name) {
      document.cookie = `${name}=; max-age=0; path=/`;
    }
  });
}